import React from "react";

//import data from '../../../../PanelComponents/CBORankingSession/data/json-data-test.json';
import ReactEcharts from "echarts-for-react";

function BarChart({ data }) {
  const option = {
    grid: {
      left: "3%",
      right: window.innerWidth <= 661 ? "10%" : "7%",
      bottom: "3%",
      top: "5%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      show: false,
      //axisLine: {
      //  show: true,
      //},
      //axisLabel: {
      //  fontSize: 10,
      //  fontWeight: 600,
      //},
      max: data.dados[0].quantidade * 1.5,
      //boundaryGap: [0, 0.01],
      //interval: Math.ceil((data.dados[0].quantidade + 50000) / 4),
    },
    yAxis: {
      type: "category",
      inverse: true,
      axisLabel: {
        show: false,
      },
      //  fontWeight: 'bold',
      //  fontSize: 10,
      //  width: window.innerWidth <= 700 ? 180 : '100%',
      //  align: 'left',
      //  overflow: 'break',
      //  //backgroundColor: '#FFF',
      //  //borderRadius: 2,
      //  textBorderColor: '#fff',
      //  textBorderWidth: 3,
      //  padding: [1, 1, 1, 1],
      //  elipsis: '...',
      //  lineHeight: 11,
      //},
      z: 10,
      axisTick: {
        alignWithLabel: false,
      },
    },
    dataZoom: [
      {
        start: 50,
        end: 0,
        orient: "vertical",
        zoomOnMouseWheel: true,
        zoomLock: false,
        minSpan: 20,
        show: true,
        yAxisIndex: 0,
        filterMode: "empty",
        width: "5%",
        handleSize: 35,
        textStyle: {
          fontSize: 0,
        },
      },
    ],
    //visualMap: {
    //  orient: 'horizontal',
    //  left: 'center',
    //  type: 'continuous',
    //  show: false,
    //  min: data.dados.length - 1,
    //  max: 0,
    //  text: ['High Score', 'Low Score'],
    //},
    series: [
      {
        //seriesLayoutBy: 'column',
        type: "bar",
        stack: "chart",
        silent: false,
        barCategoryGap: 30,
        barWidth: "90%",
        itemStyle: {
          color: "#90cbf0",
        },
        label: {
          show: true,
          formatter: (params) => {
            /*const value = `${params.value.quantidade}`.replace(
              /(\d{1,3})(?=(?:\d{3})+(?!\d))/g,
              '$1.'
            );*/
            return params.name;
          },
          position: "insideLeft",
          align: "left",
          fontWeight: "bold",
          overflow: "break",
          fontSize: "1.3rem",
          lineHeight: 10,
          width: window.innerWidth <= 530 ? window.innerWidth * 0.5 : "100%",
          rich: {
            name: {},
          },
        },
        data: data.dados.map((obj) => {
          return { name: obj.ocupacao, value: obj.quantidade };
        }),
      },
      {
        type: "bar",
        stack: "chart",
        silent: true,
        itemStyle: {
          color: "whitesmoke",
        },
        label: {
          position: "insideRight",
          show: true,
          silent: true,
          formatter: (params) => {
            const value = `${
              data.dados[0].quantidade * 1.5 - params.value
            }`.replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,");
            return value;
          },
        },
        data: data.dados.map((obj) => {
          return data.dados[0].quantidade * 1.5 - obj.quantidade;
        }),
      },
    ],
  };
  const style = {
    height: "99%",
    width: "99%",
  };
  return <ReactEcharts option={option} style={style} />;
}

export default BarChart;
